module.exports = __webpack_public_path__ + "static/media/Gulpin_gaussian2.6474be7c.png";